import { Box, Grid, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";
import Pagination from "../../../../components/Table/components/Pagination/Pagination";

interface InvoicesPaginationProps {
  page: number;
  setPage: Dispatch<SetStateAction<number>>;
  pageSize: number;
  rowLength: number;
}

const InvoicesPagination = ({
  page,
  setPage,
  pageSize,
  rowLength,
}: InvoicesPaginationProps) => {
  const theme = useTheme();
  const { t } = useTranslation("common");

  return (
    <Grid
      container
      display="flex"
      paddingTop={theme.tokens.FuelSpacing4}
      paddingBottom={theme.tokens.FuelSpacing4}
    >
      <Grid flex={2}>
        <Box display="flex">
          <Box
            data-testid="table-page-info"
            display="flex"
            flexDirection="column"
            justifyContent="center"
            paddingRight={theme.tokens.FuelSpacing3}
          >
            <Typography sx={{ color: theme.tokens.FuelColorTextTertiary }}>
              {`${t("table.pagination.results")} `}
              {(page - 1) * pageSize + 1}
              {` - `}
              {Math.min(page * pageSize, rowLength)}
              {` ${t("table.pagination.results.of")} `}
              {rowLength}
            </Typography>
          </Box>
          <Pagination
            lastVisitedPage={page}
            count={Math.ceil(rowLength / pageSize)}
            onChange={(updatedPage: number) => setPage(updatedPage)}
          />
        </Box>
      </Grid>
    </Grid>
  );
};

export default InvoicesPagination;
